/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/quiz';
import { QUIZ } from '@/store/types';
import { QuizData, QuizTopsData, QuizInvitation, QuizResponse } from '@/api/types/quiz';

export interface StoreQuizState {
  topic: QuizData;
  tops: QuizTopsData[];
  me: QuizTopsData;
  invitations: QuizInvitation;
  current: QuizResponse;
}

export default {
  namespaced: true,
  state: {
    topic: {},
    tops: [],
    me: null,
    invitations: [],
    current: null,
  },
  getters: {},
  actions: {
    [QUIZ.GET_TOPICS]({ commit }, t) {
      return new Promise((resolve, reject) => {
        api.getTopics(t).then((res) => {
          commit(QUIZ.GET_TOPICS, res.data);
          resolve();
        }).catch(reject);
      });
    },
    [QUIZ.GET_TOPS]({ commit }, { tid, limit = 100 }) {
      return new Promise((resolve, reject) => {
        api.getTops(tid, limit).then((res) => {
          commit(QUIZ.GET_TOPS, res.data);
          resolve();
        }).catch(reject);
      });
    },
    [QUIZ.GET_INVITATIONS]({ commit }, { tid, limit = 100 }) {
      return new Promise((resolve, reject) => {
        api.getInvitations(tid, limit).then((res) => {
          commit(QUIZ.GET_INVITATIONS, res.data);
          resolve();
        }).catch(reject);
      });
    },
    [QUIZ.GET_PROFILE]({ commit }, { tid, key = null }) {
      return new Promise((resolve, reject) => {
        api.getProfile(tid, key).then((res) => {
          commit(QUIZ.GET_PROFILE, res.data);
          resolve();
        }).catch(reject);
      });
    },
    [QUIZ.PUT_PROFILE](_, body) {
      return new Promise((resolve, reject) => {
        api.putProfile(body).then(() => {
          resolve();
        }).catch(reject);
      });
    },
    [QUIZ.POST_RECORDS]({ commit }, tid) {
      return new Promise((resolve, reject) => {
        api.postRecords(tid).then((res) => {
          commit(QUIZ.POST_RECORDS, res.data);
          resolve(res.data);
        }).catch(reject);
      });
    },
    [QUIZ.PUT_RECORDS]({ commit }, { rid, body }) {
      return new Promise((resolve, reject) => {
        api.putRecords(rid, body).then((res) => {
          commit(QUIZ.POST_RECORDS, res.data);
          resolve(res.data);
        }).catch(reject);
      });
    },
  },
  mutations: {
    [QUIZ.GET_TOPICS](state, topic) {
      state.topic = topic;
    },
    [QUIZ.GET_TOPS](state, { tops, me }) {
      state.tops = tops;
      state.me = me;
    },
    [QUIZ.GET_INVITATIONS](state, invitations) {
      state.invitations = invitations;
    },
    [QUIZ.GET_PROFILE](state, profile) {
      state.profile = profile;
    },
    [QUIZ.POST_RECORDS](state, current) {
      state.current = current;
    },
  },
};
